module.exports = __webpack_public_path__ + "assets/img/08a.6e36bf7d.jpg";